<template>
  <AppDialog
    v-model="dialogModel"
    width="80vw"
    scrollable
    @close="close(false)"
  >
    <template #title>
      Email Preview {{ report.reportNumber }}
    </template>
    <v-card-text class="text-gray-accent-1  preview-window">
      <div>
        From: {{ previewBody.from }}<br>
        To: {{ previewBody.to }}<br>
        Subject: {{ previewBody.subject }}<br>
      </div>
      <br>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div v-html="emailBody" />
    </v-card-text>
    <v-card-actions>
      <v-btn @click="close(false)">
        <v-icon>mdi-close</v-icon>
        Close
      </v-btn>
      <v-spacer />
      <v-btn
        color="primary"
        :disabled="!emails || !subject || saving"
        @click="submit"
      >
        <v-icon>mdi-email</v-icon>
        Send
      </v-btn>
    </v-card-actions>
  </AppDialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AppDialog from "@/components/AppDialog";

export default {
  components: { AppDialog },
  props: {
    dialog: Boolean,
    customMessage: {
      type: String,
      default: ""
    },
    subject: {
      type: String,
      default: ""
    },
    emails: {
      type: String,
      default: ""
    },
    action: {
      type: Function,
      default: null
    },
    close: {
      type: Function,
      default: null
    }
  },

  emits: ['update:dialog'],

  data() {
    return {
      mailList: [],
    }
  },
  computed: {
    ...mapGetters({
      saving: "report/details/emailSaving",
      previewBody: "report/details/emailPreview",
      report: "report/details/report",
    }),
    emailBody() {
      // template engine adds unnecessary white space when passing to the frontend,
      // so it is processed and removed here
      return this.previewBody.html.replaceAll("\n", "").replaceAll("  ", "")
    },
    dialogModel: {
      get () { return this.dialog },
      set (value) { this.$emit('update:dialog', value) },
    },
  },
  methods: {
    ...mapActions({
    }),
    submit() {
      this.action();
      this.close();
    },
  },
};
</script>

<style>
  .preview-window {
    white-space: pre-wrap;
  }
</style>
